const mapTrajet = (trajet) => {
    
    switch (trajet) {
      case "Depuis mon domicile à l'Aéroport Roland-Garros (RUN)":
        return "Dom > Aero";
        

      case "De l'Aéroport Roland-Garros (RUN) à mon domicile":
        return "Aero > Dom";
      
    }
  }

  export default mapTrajet;